//icons
import { GiMoneyStack } from "react-icons/gi";
import { AiOutlineHome, AiOutlinePieChart, AiOutlineTeam } from "react-icons/ai";
import { VscTypeHierarchySub } from "react-icons/vsc";
import { GiPartyPopper } from "react-icons/gi";
import { FiUsers } from "react-icons/fi";
import { TfiAnnouncement } from "react-icons/tfi";
import { CiCalendarDate } from "react-icons/ci";
import { RiOrganizationChart, RiTimerFlashLine } from "react-icons/ri";
import { IoFingerPrintOutline } from "react-icons/io5";
import { TbReportSearch, TbReportMoney } from "react-icons/tb";
import { HiOutlinePresentationChartLine } from "react-icons/hi";
import { CgUserList } from "react-icons/cg";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import { IoMdSettings } from "react-icons/io";
import { BsStars } from "react-icons/bs";
import { FaBusinessTime } from "react-icons/fa";
import { LuTimerReset, LuPlusCircle, LuMinusCircle } from "react-icons/lu";

const SidebarLinks = [
  {
    id: 1,
    name: "الرئيسية",
    icon: <AiOutlineHome size={18} />,
    path: "/",
    sub: [],
    allowAll: true,
  },
  {
    id: 2,
    name: " الاحصائيات",
    icon: <HiOutlinePresentationChartLine size={20} />,
    path: "/statistics",
    sub: [],
    roles: [],
    permissionName: "statistics_view",
  },
  {
    id: 3,
    name: "الموظفين",
    icon: <FiUsers size={18} />,
    path: "/employee",
    sub: [],
    roles: [],
    permissionName: "user_view",
  },
  {
    id: 19,
    name: "تقييم الموظفين",
    icon: <BsStars size={18} />,
    path: "/employee-ratings",
    sub: [],
    // roles: ["super-admin", "manager", "user"],
    roles: ["user"],
    has_team_required: true,
    permissionName: "evaluation_view",
  },
  {
    id: 4,
    name: "تغيير الشفت",
    icon: <CgUserList size={18} />,
    path: "/shifts",
    sub: [],
    // roles: ["super-admin", "reception", "reception_supervisor"],
    roles: [],
    permissionName: "change_shift_view",
  },
  {
    id: 5,
    name: "بصماتي",
    icon: <IoFingerPrintOutline size={18} />,
    path: "/my-attendance",
    sub: [],
    allowAll: true,
  },
  {
    id: 6,
    name: "الحضور و الأنصراف",
    icon: <IoFingerPrintOutline size={18} />,
    path: "/attendance",
    sub: [],
    // roles: ["super-admin", "manager", "user", "reception_supervisor", "reception"],
    roles: ["user"],
    has_team_required: true,
    permissionName: "attendance_view",
  },
  {
    id: 62,
    name: "اعضاء الفريق",
    icon: <AiOutlineTeam size={18} />,
    path: "/team-leader",
    sub: [],
    roles: ["user"],
    has_team_required: true,
  },
  {
    id: 7,
    name: "الأقسام",
    icon: <VscTypeHierarchySub size={18} />,
    path: "/departments",
    sub: [],
    roles: [],
    permissionName: "department_view",
  },
  {
    id: 8,
    name: "الإعلانات",
    icon: <TfiAnnouncement size={18} />,
    path: "/announcements",
    sub: [],
    roles: [],
    permissionName: "announcement_view",
  },
  {
    id: 9,
    name: "العطلات",
    icon: <GiPartyPopper size={20} />,
    path: "/holidays",
    sub: [],
    roles: [],
    permissionName: "holiday_view",
  },
  {
    id: 10,
    name: "اوقات السماح",
    icon: <RiTimerFlashLine size={20} />,
    path: "/flexibility",
    sub: [],
    roles: [],
    permissionName: "flexibility_view",
  },
  {
    id: 11,
    name: "الآجازات",
    icon: <CiCalendarDate size={20} />,
    path: "/leave",
    sub: [],
    allowAll: true,
  },
  {
    id: 21,
    name: "طلب دوام اونلاين",
    icon: <CiCalendarDate size={20} />,
    path: "/remotely-extra",
    sub: [],
    // roles: [
    //   "user",
    //   "manager",
    //   "super-admin",
    //   "reception",
    //   "finance",
    //   "reception_supervisor",
    // ],
    allowAll: true,
  },
  {
    id: 12,
    name: "التبليغات و الأشعارات",
    icon: <CiCalendarDate size={20} />,
    path: "/notifications",
    sub: [],
    allowAll: true,
  },
  {
    id: 13,
    name: "التقارير",
    icon: <TbReportSearch size={20} />,
    path: "/reports",
    sub: [],
    roles: [],
    // roles: ["super-admin", "finance", "reception_supervisor"],
    permissionName: "reports_view",
  },
  {
    id: 14,
    name: "المكافئات",
    icon: <LuPlusCircle size={20} />,
    path: "/bonuses",
    sub: [],
    // roles: ["super-admin", "manager", "finance", "user", "reception_supervisor"],
    // roles: ["user"],
    // permissionName: "bonus_view",
    allowAll: true,
  },
  {
    id: 142,
    name: "الأنذارات و الخصومات",
    icon: <LuMinusCircle size={20} />,
    path: "/cuts",
    sub: [],
    // roles: ["super-admin", "manager", "finance", "user", "reception_supervisor"],
    allowAll: true,
  },
  {
    id: 678,
    name: "الاوقات الاضافية",
    icon: <LuTimerReset size={20} />,
    path: "/suspension-overtime",
    sub: [],
    // roles: ["super-admin", "manager", "user", "reception_supervisor"],
    roles: ["user"],
    has_team_required: true,
    permissionName: "suspension_over_time_view",
  },
  {
    id: 140,
    name: "مكافئات الساعات الاضافية",
    icon: <FaBusinessTime size={20} />,
    path: "/overtime",
    sub: [],
    // roles: ["super-admin", "manager", "finance", "user", "reception_supervisor"],
    allowAll: true,
  },
  {
    id: 15,
    name: "القروض",
    icon: <TbReportMoney size={20} />,
    path: "/advance-payment",
    sub: [],
    roles: [],
    // roles: ["super-admin", "finance"],
    permissionName: "advance_payment_view",
  },
  {
    id: 16,
    name: "الرواتب",
    icon: <GiMoneyStack size={20} />,
    path: "/salary",
    sub: [],
    roles: [],
    // roles: ["super-admin", "finance"],
    permissionName: "salary_view",
  },
  {
    id: 17,
    name: "ادارة الرواتب",
    icon: <GiMoneyStack size={20} />,
    path: "/manage-salary",
    sub: [],
    roles: [],
    // roles: ["super-admin", "finance"],
    permissionName: "salary_view",
  },
  {
    id: 18,
    name: "الاعدادات",
    icon: <IoMdSettings size={20} />,
    path: "/settings",
    sub: [],
    roles: [],
    // roles: ["super-admin", "reception_supervisor"],
    permissionName: "settings_view",
  },
  {
    id: 22,
    name: "تقييم أداء الموظفين",
    icon: <AiOutlinePieChart size={20} />,
    path: "/kpi",
    sub: [],
    roles: [],
    // roles: ["super-admin"],
    permissionName: "statistics_view"
  },
  {
    id: 20,
    name: "الهيكل الإداري",
    icon: <RiOrganizationChart size={20} />,
    path: "/company-tree",
    sub: [],
    roles: [],
    // roles: ["super-admin"],
    permissionName: "tree_department_view",
  },
];

export default SidebarLinks;
